import { useNavigate } from "react-router-dom";
import { Image, Text, Button, Heading, Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import successIcon from "../../assets/cardSuccess.png";

export function AddPaymentSuccessPage() {
  const navigate = useNavigate();

  return (
    <Stack spacing={0} h="100svh" pb="100px" alignItems="center" justifyContent="center" textAlign="center">
      <Image boxSize="173px" src={successIcon} mb="22px" />
      <Heading mb="8px">Способ оплаты на проверке</Heading>

      <Text maxW="300px">
        Этот способ оплаты будет добавлен как
        основной способ погашения по графику
        после проверки
      </Text>

      <Button w="300px" mt="32px" colorScheme="purple" onClick={() => { navigate(RoutesMap.cards.index); }}>
        К способам оплаты
      </Button>
    </Stack>
  );
}
